/**
 * relivConference.relivConferenceTicketsSelector
 */
angular.module('relivConference').directive(
    'relivConferenceTicketsSelector',
    [
        '$window',
        'relivConferenceService',
        'relivConferenceOrderService',
        'relivConferenceModelFactory',
        'rcmApiLibMessageService',
        'rcmLoading',
        'profileRepository',
        'translateFilter',
        function (
            $window,
            relivConferenceService,
            relivConferenceOrderService,
            relivConferenceModelFactory,
            rcmApiLibMessageService,
            rcmLoading,
            profileRepository,
            translateFilter
        ) {
            var thisLink = function (scope, element, attr) {

                var messageNamespace = 'relivConferenceTicketsSelector';

                scope.lookupAccess = false;

                scope.profileSearchResults = [];

                scope.profileSearchProperties = [
                    {
                        name: 'name',
                        label: 'Search by last name (optional):',
                        placeholder: 'last name',
                    },
                ];

                scope.profileSearchResultProperties = [
                    {
                        name: 'name',
                        label: 'Name',
                    },
                    {
                        name: 'email',
                        label: 'Email',
                    },
                    {
                        name: 'rcn',
                        label: 'RCN',
                    },
                ];

                scope.displayProfileSearchResults = false;

                /**
                 * conferenceItems
                 * @type {*}
                 */
                scope.conferenceItems = [];

                /**
                 * hasConferenceItems
                 * @type {boolean}
                 */
                scope.hasConferenceItems = false;

                /**
                 * addAnimationCss
                 * @type {boolean}
                 */
                scope.addAnimationCss = false;

                /**
                 * showSubmit
                 * @type {boolean}
                 */
                scope.showSubmit = false;

                /**
                 * loading
                 * @type {boolean}
                 */
                scope.loading = true;

                /**
                 *
                 * @type {Array}
                 */
                scope.conferences = [];
                /**
                 *
                 * @type {{conferenceId: {conferenceIndex}}}
                 */
                scope.conferencesIndex = {};

                /**
                 *
                 * @type {{}}
                 */
                scope.typeLabels = {};

                /**
                 * fieldMessages
                 * @type {Array}
                 */
                scope.fieldMessages = [];

                /**
                 * user.rcn
                 * @type {number}
                 */
                scope.currentUser = {
                    rcn: null,
                    firstName: null,
                    lastName: null,
                    city: null,
                    state: null,
                };

                /**
                 * ticketOptions
                 * @type {{translationLangCode: *[], hearingImpaired: *[], signLanguage: *[]}}
                 */
                scope.ticketOptions = relivConferenceService.ticketOptions;

                /**
                 *
                 * @type {{conferenceCheckoutBlockerException: boolean, validatorMessage: boolean}}
                 */
                var validMessageSource = {
                    conferenceCheckoutBlockerException: true,
                };

                var validMessageType = {
                    validatorMessage: true,
                };

                /**
                 * setFieldMessages
                 * @param messages
                 */
                var setFieldMessages = function (messages) {
                    scope.fieldMessages = messages;
                };

                /**
                 * clearFieldMessages
                 */
                var clearFieldMessages = function () {
                    scope.fieldMessages = [];
                };

                /**
                 * addMessage
                 * @param message
                 */
                var addMessage = function (message) {
                    if (!message) {
                        return;
                    }
                    message.value = translateFilter(message.value);
                    scope.hasMessage = true;
                    rcmApiLibMessageService.addMessage(message, messageNamespace);
                };

                /**
                 * handleMessages
                 * @param messages
                 */
                var handleMessages = function (messages) {
                    rcmApiLibMessageService.clearMessages(messageNamespace);
                    clearFieldMessages();

                    rcmApiLibMessageService.getTypeMessages(
                        messages,
                        'validatorMessage',
                        setFieldMessages
                    );

                    rcmApiLibMessageService.getPrimaryMessage(
                        messages,
                        addMessage
                    );
                };

                /**
                 * onApiError
                 * @param response
                 */
                var onApiError = function (response) {
                    handleMessages(response.messages);
                };

                /**
                 * getOrderConferenceItems
                 */
                var getOrderConferenceItems = function () {
                    return relivConferenceOrderService.getOrderConferenceItems(
                        scope.conferenceItems,
                        function (conferenceItems, messages) {
                            handleMessages(messages);
                            onConferenceItemsSuccess(conferenceItems);
                        }
                    );
                };

                /**
                 * onConferenceItemsSuccess
                 * @param conferenceItems
                 */
                var onConferenceItemsSuccess = function (conferenceItems) {
                    scope.hasConferenceItems = (conferenceItems.length > 0);
                    scope.conferenceItems = conferenceItems;

                    for (var i = 0; i < scope.conferenceItems.length; i++) {
                        scope.conferenceItems[i] = getNewTicketFromExisting(scope.conferenceItems[i]);
                    }

                    if (scope.conferenceItems.length == 0) {
                        scope.addTicket();
                    }
                    scope.loading = false;
                    // @todo Why??
                    scope.$apply();
                };

                /**
                 * update
                 */
                var update = function () {
                    rcmLoading.setLoading(
                        'relivConferenceTicketsSelector.update.loading',
                        0
                    );
                    relivConferenceOrderService.updateOrderConferenceItems(
                        scope.conferenceItems,
                        function (conferenceItems, messages) {
                            updateCheck(messages);
                        },
                        function (response) {
                            updateCheck(response.messages);
                        }
                    );
                };

                /**
                 * submitTickets
                 */
                scope.submitTickets = function () {
                    update();
                };

                /**
                 *
                 * @param messages
                 */
                var updateCheck = function (messages) {

                    var validMessages = [];
                    var hasMessages = (messages.length > 0);

                    for (var i = 0; i < messages.length; i++) {
                        if (validMessageSource[messages[i].source]) {
                            validMessages.push(messages[i]);
                            continue;
                        }

                        if (validMessageType[messages[i].type]) {
                            validMessages.push(messages[i]);
                        }
                    }

                    if (hasMessages) {
                        handleMessages(messages);
                    }

                    if (!hasMessages) {
                        // @todo can user orderMgr.getNextPage();
                        $window.location.href = '/checkout/cart';
                        return;
                    }

                    rcmLoading.setLoading(
                        'relivConferenceTicketsSelector.update.loading',
                        1
                    );
                };

                /**
                 * onApiSuccess
                 * @param response
                 */
                var onConferenceSuccess = function (response) {
                    rcmApiLibMessageService.clearMessages(messageNamespace);
                    scope.conferences = response.data;
                    buildTypeLabelsIndex(scope.conferences);
                    scope.conferencesIndex = relivConferenceService.indexConferences(
                        scope.conferences,
                        scope.conferencesIndex
                    );
                };

                /**
                 *
                 * @param conferences
                 */
                var buildTypeLabelsIndex = function (conferences) {

                    scope.typeLabels = {};

                    for (var key in conferences) {
                        if (!conferences.hasOwnProperty(key)) {
                            continue;
                        }

                        if (!conferences[key].ticketProduct) {
                            console.warn('No ticket product found');
                            continue;
                        }

                        if (!conferences[key].ticketProduct.optionGroups[0]) {
                            console.warn('No option group found');
                            continue;
                        }

                        var str = conferences[key].ticketProduct.optionGroups[0].name;
                        scope.typeLabels[conferences[key].id] = str.replace(/"/g, '');
                    }
                };

                /**
                 * getConferences
                 * @returns {Promise}
                 */
                var getConferences = function () {
                    return relivConferenceService.getConferences(
                        onConferenceSuccess,
                        onApiError
                    );
                };

                /**
                 *
                 * @param conferenceId
                 * @returns {*}
                 */
                var getConferenceIndex = function (conferenceId) {
                    if (!conferenceId) {
                        for (var id in scope.conferencesIndex) {
                            // return the first in the list
                            return scope.conferencesIndex[id];
                        }
                        // no conferences
                        return null;
                    }

                    return scope.conferencesIndex[conferenceId];
                };

                /*
                 * onUserDataSuccess
                 * @param response
                 */
                var onUserDataSuccess = function (response) {
                    scope.currentUser = prepareUserProfile(response.data.properties.vistaProfile);
                };

                /**
                 *
                 * @param userProfile
                 * @returns {*}
                 */
                var prepareUserProfile = function (userProfile) {
                    return {
                        rcn: userProfile.rcn,
                        firstName: userProfile.primaryFirstName,
                        lastName: userProfile.primaryLastName,
                        city: userProfile.billAddress.city,
                        state: userProfile.billAddress.state,
                    };
                };

                /*
                 * onUserDataError
                 */
                var onUserDataError = function (response) {
                    console.error('Error getting user data: '.JSON.stringify(response.messages));
                };

                /**
                 * getCurrentUserInfo
                 * @returns {Promise}
                 */
                var getCurrentUserInfo = function () {
                    return relivConferenceOrderService.getCurrentUser(
                        onUserDataSuccess,
                        onUserDataError
                    );
                };

                /**
                 * @param conferenceItem
                 */
                scope.handleAutoPopulateUser = function (conferenceItem) {

                    profileRepository.findById(conferenceItem.displayRcn).then(
                        function (response) {
                            var userProfile = prepareUserProfile(response.data);
                            conferenceItem = autoPopulateConferenceItem(conferenceItem, userProfile);
                            scope.$apply();
                        }
                    ).catch(
                        function () {
                            $window.alert('User not found');
                        }
                    );
                };

                /**
                 *
                 * @param search
                 * @param conferenceItem (searchId)
                 */
                scope.handleSearchSubmit = function (search, conferenceItem) {

                    scope.hideProfileSearchResults();

                    var params = {};
                    for (var key in search) {
                        params['filter[where][' + key + ']'] = search[key];
                    }

                    profileRepository.find(params).then(
                        function (response) {
                            scope.profileSearchResults = response.data;
                            scope.showProfileSearchResults();
                            scope.$apply();
                        }
                    ).catch(
                        function (response) {
                            scope.profileSearchResults = [];
                            scope.showProfileSearchResults();
                            scope.$apply();
                        }
                    );
                };

                scope.showProfileSearchResults = function () {
                    scope.displayProfileSearchResults = true;
                };

                scope.hideProfileSearchResults = function () {
                    scope.displayProfileSearchResults = false;
                };

                /**
                 *
                 * @param userProfile
                 * @param conferenceItem (searchId)
                 */
                scope.handleSearchResultSelect = function (userProfile, conferenceItem) {
                    userProfile = prepareUserProfile(userProfile);
                    conferenceItem = autoPopulateConferenceItem(conferenceItem, userProfile);
                    scope.hideProfileSearchResults();
                    //scope.$apply();
                };

                /**
                 * @todo Service Layer?
                 * @param conferenceItem
                 * @param userProfile
                 * @returns {*}
                 */
                var autoPopulateConferenceItem = function (conferenceItem, userProfile) {
                    conferenceItem.displayRcn = userProfile.rcn;
                    conferenceItem.firstName = userProfile.firstName;
                    conferenceItem.lastName = userProfile.lastName;
                    conferenceItem.city = userProfile.city;
                    conferenceItem.stateCountry = userProfile.state;
                    conferenceItem.hearingImpaired = 0;
                    conferenceItem.signLanguage = 0;

                    return conferenceItem;
                };

                /**
                 *
                 * @param conferenceId
                 * @param conferenceItemIndex
                 */
                scope.handleConferenceChange = function (conferenceId, conferenceItemIndex) {
                    // Clear existing feature data as it cannot be valid if conference changed
                    scope.conferenceItems[conferenceItemIndex].featureData = [];
                    scope.conferenceItems[conferenceItemIndex] = getNewTicketFromExisting(
                        scope.conferenceItems[conferenceItemIndex]
                    );
                };

                /**
                 * @todo Service Layer?
                 * @param existingConferenceItem
                 * @returns {*}
                 */
                var getNewTicketFromExisting = function (existingConferenceItem) {
                    if (!existingConferenceItem) {
                        return scope.getNewTicket();
                    }
                    var conferenceItem = angular.copy(existingConferenceItem);
                    // clear conference related data
                    conferenceItem.productId = null;
                    conferenceItem.skuNumber = null;
                    conferenceItem.productOptions = {};

                    conferenceItem = prepareConferenceItem(conferenceItem);

                    return conferenceItem;
                };

                /**
                 * @todo Service Layer?
                 * @returns {*}
                 */
                scope.getNewTicket = function () {
                    var conferenceItem = relivConferenceModelFactory.newTicket();

                    conferenceItem = prepareConferenceItem(conferenceItem);

                    return conferenceItem;
                };

                /**
                 * @todo Service Layer?
                 * @param conferenceItem
                 * @returns {*}
                 */
                var autoSelectConference = function (conferenceItem) {
                    var conferenceIdKeys = Object.keys(scope.conferencesIndex);

                    if (conferenceIdKeys.length == 1) {
                        conferenceItem.conferenceId = Number(conferenceIdKeys[0]);
                    }

                    return conferenceItem;
                };

                /**
                 * @todo Service Layer?
                 * @param conferenceItem
                 * @returns {*}
                 */
                var autoSelectTicket = function (conferenceItem) {
                    var skuKeys = Object.keys(conferenceItem.productOptions);

                    if (skuKeys.length == 1) {
                        conferenceItem.skuNumber = skuKeys[0];
                        conferenceItem.productId = conferenceItem.productOptions[skuKeys[0]].productId;
                    }

                    return conferenceItem;
                };

                /**
                 * @todo Service Layer?
                 * @param conferenceItem
                 * @returns {*}
                 */
                var prepareConferenceItem = function (conferenceItem) {
                    conferenceItem = autoSelectConference(conferenceItem);

                    if (!conferenceItem.conferenceId) {
                        conferenceItem.productId = null;
                        conferenceItem.productOptions = {};
                        return prepareConferenceItemFeatureData(conferenceItem);
                    }

                    var conferenceIndex = getConferenceIndex(conferenceItem.conferenceId);

                    conferenceItem.productId = conferenceIndex.ticketProduct.productId;

                    // Build ticket options
                    conferenceItem.productOptions = getProductOptions(
                        conferenceItem.conferenceId,
                        conferenceItem.productId,
                        conferenceItem.skuNumber,
                        conferenceIndex.ticketProduct
                    );

                    conferenceItem = prepareConferenceItemFeatureData(conferenceItem);

                    return autoSelectTicket(conferenceItem);
                };

                /**
                 * @todo Service Layer?
                 * @param conferenceItem
                 * @returns {*}
                 */
                var prepareConferenceItemFeatureData = function (conferenceItem) {
                    if (!conferenceItem.conferenceId) {
                        conferenceItem.featureData = [];
                        return conferenceItem;
                    }

                    var conferenceIndex = getConferenceIndex(conferenceItem.conferenceId);
                    var skuIndex = conferenceIndex.skuIndex;
                    var preparedFeatureData = [];
                    for (var i in conferenceItem.featureData) {
                        if (!skuIndex[conferenceItem.featureData[i].productId]) {
                            continue;
                        }

                        var featureData = angular.copy(conferenceItem.featureData[i]);

                        featureData.productOptions = getProductOptions(
                            conferenceItem.conferenceId,
                            featureData.productId,
                            featureData.skuNumber,
                            skuIndex[featureData.productId]
                        );

                        preparedFeatureData.push(featureData);
                    }

                    conferenceItem.featureData = preparedFeatureData;

                    return conferenceItem;
                };

                /**
                 * @todo Service Layer?
                 * @param conferenceId
                 * @param selectedProductId
                 * @param selectedSkuNumber
                 * @param availableProduct
                 * @returns {*}
                 */
                var getProductOptions = function (
                    conferenceId,
                    selectedProductId,
                    selectedSkuNumber,
                    availableProduct
                ) {
                    if (!conferenceId) {
                        return {};
                    }

                    var conferenceIndex = getConferenceIndex(conferenceId);
                    var skuIndex = conferenceIndex.skuIndex;

                    if (!selectedProductId || !selectedSkuNumber) {
                        return angular.copy(skuIndex[availableProduct.productId].availableSkus);
                    }

                    if (!skuIndex[selectedProductId]) {
                        return angular.copy(skuIndex[availableProduct.productId].availableSkus);
                    }

                    if (skuIndex[selectedProductId].availableSkus[selectedSkuNumber]) {
                        return angular.copy(skuIndex[selectedProductId].availableSkus);
                    }

                    if (skuIndex[selectedProductId].skus[selectedSkuNumber]) {
                        var productOptions = angular.copy(skuIndex[selectedProductId].availableSkus);
                        productOptions[selectedProductId].availableSkus[selectedSkuNumber] =
                            angular.copy(skuIndex[selectedProductId].skus[selectedSkuNumber]);
                        productOptions.invalid = true;
                        return productOptions;
                    }

                    return angular.copy(skuIndex[availableProduct.productId].availableSkus);
                };

                /**
                 * addTicket
                 */
                scope.addTicket = function () {
                    var conferenceItem = scope.getNewTicket();

                    scope.showSubmit = true;
                    scope.hasConferenceItems = true;

                    if (scope.conferenceItems.length == 0) {
                        conferenceItem = autoPopulateConferenceItem(conferenceItem, scope.currentUser);
                    }

                    if (scope.conferenceItems[conferenceItem.uid]) {
                        console.error('Duplicate uid created for ticket' + conferenceItem.uid);
                        return;
                    }

                    scope.conferenceItems.push(conferenceItem);
                    scope.addAnimationCss = true;
                };

                /**
                 * removeTicket
                 */
                scope.removeTicket = function (conferenceItem) {

                    $().confirm(
                        'Are you sure you want to delete this ticket?',
                        function () {
                            var index = scope.conferenceItems.indexOf(conferenceItem);
                            scope.conferenceItems.splice(index, 1);
                            rcmApiLibMessageService.clearMessages(messageNamespace);
                            scope.$apply();
                        }
                    );
                };

                /**
                 * addFeature
                 * @param conferenceItem
                 * @param feature
                 */
                scope.addFeature = function (conferenceItem, feature) {
                    if (!feature) {
                        return;
                    }
                    var newFeature = angular.copy(feature);
                    conferenceItem.featureData.push(newFeature);
                    conferenceItem = prepareConferenceItem(conferenceItem);
                    return conferenceItem;
                };

                /**
                 * removeFeature
                 * @param conferenceItem
                 * @param feature
                 */
                scope.removeFeature = function (conferenceItem, feature) {
                    var index = conferenceItem.featureData.indexOf(feature);
                    conferenceItem.featureData.splice(index, 1);
                    conferenceItem = prepareConferenceItem(conferenceItem);
                    return conferenceItem;
                };

                /**
                 *
                 */
                var getConferenceAccess = function () {
                    relivConferenceService.getConferenceAccess().then(
                        function (response) {
                            scope.lookupAccess = response.data;
                        }
                    );
                };

                /**
                 * Run on init
                 */
                var init = function () {
                    getCurrentUserInfo(
                    ).then(
                        getConferences
                    ).then(
                        getOrderConferenceItems
                    ).catch(
                        onApiError
                    );

                    getConferenceAccess();
                };

                init();
            };

            return {
                link: thisLink,
                restrict: 'A',
                template: require('./reliv-conference-tickets.html'),
            };
        },
    ]
);
